import $ from 'jquery';
import MicroModal from "micromodal";
// 卒業予定年月確認モーダル

const setup = (modal) => {
    // 更新するボタン
    $(document).on(oEventNames.end, '#modal-graduation-year .js-graduation-year-submit', function (event) {
        if (!bIsScrolling) {
            event.preventDefault();
            // postするデータ
            const graduationY = $('#graduation_y').val();
            const graduationM = $('#graduation_m').val();
            const postData = {
                graduationY,
                graduationM,
            };

            $.ajax({
                headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                url: '/ajax/users/graduation',
                type: 'POST',
                dataType: 'json',
                data: postData,
            })
            // Ajaxリクエストが成功した時発動
            .done((data) => {
                // /mypage/profileを表示しているなら「卒業予定（年） 」と「卒業予定（月）」の欄があるので更新する
                $('select#graduation_y').val(graduationY);
                $('select#graduation_m').val(graduationM);
                // /mypageを表示しているなら「就職活動の状況」欄があるので更新によって就職活動期間でなくなった場合は非表示にする
                if (data.jobStatusReset) {
                    $('div.account-about.job-status').hide();
                }
                $.toast({
                    heading: '卒業予定年月を保存しました。',
                    text: '',
                    showHideTransition: 'slide',
                    icon: 'success',
                    position: 'bottom-right',
                    hideAfter: 6000,
                });
            })
            // Ajaxリクエストが失敗した時発動
            .fail((data) => {
                $.toast({
                    heading: '卒業予定年月の保存に失敗しました。',
                    text: 'お手数ですが、マイページの「基本情報編集」ページで再度卒業予定年月を設定いただき、それでも失敗する場合はお問い合わせくださいませ。',
                    showHideTransition: 'slide',
                    icon: 'error',
                    position: 'bottom-right',
                    hideAfter: 8000,
                });
            })
            // Ajaxリクエストが成功・失敗どちらでも発動
            .always((data) => {
                // 何らかの理由で失敗が連続するとモーダルの後に進めなくなるので失敗でも先に進める
                MicroModal.close('modal-graduation-year');
            });
        }
    });
};

const modalGraduationYear = {
    modalId: 'modal-graduation-year',
    preventEscapeKey: true,
    onShowExtra: null,
    onCloseExtra: null,
    setup,
};

export default modalGraduationYear;
